import { RecommendedTagParams } from 'common/types/params'
import { RecommendedTagState } from 'common/types/state'
import { axios } from 'common/utils'

export const fetchRecommendedTags = async (params: RecommendedTagParams): Promise<RecommendedTagState> => {
  const result = await axios.get<RecommendedTagState>('/v1/recommended-tags', {
    params,
  })
  return result && result.data
}
